import { Tag } from 'antd';
import styled from 'styled-components';

export const TagLayout = styled(Tag)`
    border-radius: 8px;
`;
